/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseNotificationData } from './BaseNotificationData';
export type GameVersionApprovedNotification = (BaseNotificationData & {
    gameId: number;
    gameVersion: number;
    type: GameVersionApprovedNotification.type;
});
export namespace GameVersionApprovedNotification {
    export enum type {
        GAME_APPROVED = 'game_approved',
    }
}

